import { get } from 'mobx';
import { ShowHelp } from '../field/enum';
export const defaultMinWidth = 100;
export const defaultAggregationMinWidth = 250;
export function defaultAggregationRenderer({ text }) {
    return text;
}
export const ColumnDefaultProps = {
    hidden: false,
    lock: false,
    resizable: true,
    sortable: false,
    hideable: true,
    aggregationLimit: 4,
    showHelp: ShowHelp.tooltip,
};
const Column = function Column() {
    return null;
};
Column.__PRO_TABLE_COLUMN = true;
Column.defaultProps = ColumnDefaultProps;
export default Column;
export function minColumnWidth(col) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    const min = get(col, 'minWidth');
    const aggregation = get(col, 'aggregation');
    const minWidth = min === undefined ? aggregation ? defaultAggregationMinWidth : defaultMinWidth : min;
    if (width === undefined) {
        return minWidth;
    }
    return Math.min(width, minWidth);
}
export function columnWidth(col) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    if (width === undefined) {
        const minWidth = get(col, 'minWidth');
        if (minWidth === undefined) {
            const aggregation = get(col, 'aggregation');
            return aggregation ? defaultAggregationMinWidth : defaultMinWidth;
        }
        return minWidth;
    }
    return width;
}
